"use client";
import dayjs from "dayjs";
import { ItemProps } from "./item.types";
import React, { FC } from "react";
import { StatusIcon } from "@/components/ui/status";
import { WorkflowStatus } from "@prisma/client";
import clsx from "clsx";
import { CurrencyValue } from "@/components/ui/currency-value";
import classes from "./item.module.css";
import { EntityImage } from "@/components/ui";

const Item: FC<ItemProps> = ({
  label,
  description,
  date,
  showDate = true,
  amount,
  currency,
  isSelected,
  status,
  onClick,
  image,
  className,
}) => {
  return (
    <div
      className={clsx(
        classes["item"],
        `flex flex-row gap-1 justify-between`,
        isSelected && classes["selected-transaction"],
        className
      )}
      tabIndex={0}
      onClick={onClick}
      onKeyUp={(event) =>
        (event.key === "Enter" || event.key === "Tab") && onClick && onClick()
      }
    >
      <div className="flex items-center gap-2">
        {status && <StatusIcon status={status || WorkflowStatus.PENDING} />}

        <EntityImage className={"mr-2"} {...image} />

        <div className="transaction-list-item-info flex flex-col gap-1">
          <div className="transaction-list-item-info-title text-sm flex flex-row gap-1 items-center">
            <span className="text-xs text-gray-500">{label}</span>
            {date && showDate && (
              <div className="text-xs text-gray-500">
                {dayjs(date).format("h:mma")}
              </div>
            )}
          </div>
          {description && (
            <div className="transaction-list-item-info-description capitalize ">
              {description}
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-row gap-1 items-center">
        {/*TODO: Implement Tags */}

        {amount !== undefined && currency ? (
          <CurrencyValue size={"L"} amount={amount} currency={currency} />
        ) : null}
      </div>
    </div>
  );
};

export { Item };
